<div class="container">
    <ui-view name="content"></ui-view>
</div>